import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useResettableForm } from "web_myplann/Shared/Hooks/useResettableForm";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { requiredPositiveAmount } from "web_myplann/Shared/Validation/requiredPositiveAmount";
import { z } from "zod";

const getExpenseAmountFormSchema = (t: TranslateFunction) => {
	const required = t(Resources.Form.Validations.required);

	return z.object({
		monthlyPayment: requiredPositiveAmount(
			required,
			t(Resources.Form.Validations.amountPositive),
		),
		sustainableAmount: z.number().min(0).nullable(),
	});
};

type ExpenseAmountFormSchema = ReturnType<typeof getExpenseAmountFormSchema>;

export type ExpenseAmountValues = z.input<ExpenseAmountFormSchema>;
export type ExpenseAmountFormModel = z.output<ExpenseAmountFormSchema>;

const EMPTY_VALUES: ExpenseAmountValues = {
	monthlyPayment: null,
	sustainableAmount: null,
};

type Params = {
	open: boolean;
	initialValues?: ExpenseAmountValues;
};

export const useExpenseAmountForm = ({ open, initialValues }: Params) => {
	const { t } = useResource();

	return useResettableForm<ExpenseAmountValues, ExpenseAmountFormModel>({
		schema: getExpenseAmountFormSchema(t),
		open,
		emptyValues: EMPTY_VALUES,
		initialValues,
	});
};
